// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1236px) {
  .addmrginresponsive-video {
    margin-bottom: 0rem !important;
  }
  .addwh-image {
    width: 100% !important;
  }
}
@media screen and (max-width: 991px) {
  .addmrginresponsive-video {
    margin-bottom: 1rem !important;
  }
}
@media screen and (max-width: 850px) {
  .addmrginresponsive-video {
    margin-bottom: 0rem !important;
  }
}
@media screen and (max-width: 768px) {
  .addmrginresponsive-video {
    margin-bottom: 1rem !important;
  }
  .addmarginbtm-responsiveimage {
    margin-bottom: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/responsive.scss"],"names":[],"mappings":"AAGA;EACI;IACI,8BAAA;EAFN;EAKE;IACI,sBAAA;EAHN;AACF;AAMA;EACI;IACI,8BAAA;EAJN;AACF;AAOA;EACI;IACI,8BAAA;EALN;AACF;AAQA;EACI;IACI,8BAAA;EANN;EASE;IACI,qBAAA;EAPN;AACF","sourcesContent":["@media screen and (max-width: 1236px) {\n}\n\n@media screen and (max-width: 1236px) {\n    .addmrginresponsive-video {\n        margin-bottom: 0rem !important;\n    }\n\n    .addwh-image {\n        width: 100% !important;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .addmrginresponsive-video {\n        margin-bottom: 1rem !important;\n    }\n}\n\n@media screen and (max-width: 850px) {\n    .addmrginresponsive-video {\n        margin-bottom: 0rem !important;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .addmrginresponsive-video {\n        margin-bottom: 1rem !important;\n    }\n\n    .addmarginbtm-responsiveimage {\n        margin-bottom: 1.5rem;\n    }\n\n    // .addwh-image {\n    //     width: 63% !important;\n    // }\n}\n\n@media screen and (max-width: 640px) {\n    // .addwh-image {\n    //     width: 63% !important;\n    // }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
